const contactCards = [
  {
    title: "在线客服",
    channel: "客服支持 · 常见问题",
    icon: "ri-customer-service-2-line",
    tone: "bg-primary-100 text-primary-700",
    note: "工作日 09:00–21:00 在线",
    cta: "进入在线客服",
    badge: "最快",
  },
  {
    title: "商务合作邮箱",
    channel: "business@chigua-official.com",
    icon: "ri-mail-line",
    tone: "bg-accent-100 text-accent-700",
    note: "品牌 / 内容 / 渠道合作均适用",
    cta: "复制邮箱",
    badge: "商务团队",
  },
  {
    title: "内容投稿 / 创作者入驻",
    channel: "creator@chigua-official.com",
    icon: "ri-pencil-ruler-2-line",
    tone: "bg-secondary-100 text-secondary-800",
    note: "面向创作者与投稿作者",
    cta: "复制邮箱",
    badge: "创作者",
  },
];

export default function Contact() {
  const copyMail = (mail: string) => {
    try {
      void navigator.clipboard.writeText(mail);
    } catch {
      /* 静默处理，静态站不接真实复制 */
    }
  };

  return (
    <section id="contact" className="bg-background-100/60 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-12">
          {/* left intro + service promise */}
          <div className="lg:col-span-5">
            <span className="text-xs font-semibold tracking-[0.3em] text-primary-600">
              CONTACT US
            </span>
            <h2 className="mt-2 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-4xl">
              联系吃瓜官网团队
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-foreground-700">
              这是吃瓜官网联系方式与对接入口的官方汇总。需要客服协助、内容合作或商务洽谈，
              按需选择对应入口即可，全部诉求均会得到妥善回应。
            </p>

            <div className="mt-8 space-y-4">
              {[
                {
                  q: "客服响应时效？",
                  a: "在线客服工作日 09:00–21:00 在线，复杂问题 1 个工作日内答复。",
                },
                {
                  q: "商务合作流程？",
                  a: "通过商务邮箱提交意向后，商务团队会在 1 个工作日内与你联系对齐方案。",
                },
                {
                  q: "如何核实渠道真伪？",
                  a: "仅以本页「官方渠道矩阵」列出的账号为准，谨防第三方仿冒。",
                },
              ].map((item) => (
                <div
                  key={item.q}
                  className="rounded-lg border border-background-200/80 bg-background-50 p-5"
                >
                  <p className="flex items-start gap-2 font-semibold text-foreground-950">
                    <i className="ri-question-line mt-0.5 text-primary-600"></i>
                    {item.q}
                  </p>
                  <p className="mt-2 pl-6 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                </div>
              ))}
            </div>
          </div>

          {/* right contact channels */}
          <div className="lg:col-span-7">
            <div className="rounded-xl border border-background-200 bg-background-50 p-6 md:p-8">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-xl font-bold text-foreground-950">
                  官方对接入口
                </h3>
                <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
                  <i className="ri-checkbox-circle-line mr-1 align-middle"></i>
                  全部为官方渠道
                </span>
              </div>

              <div className="mt-6 space-y-4">
                {contactCards.map((c) => (
                  <div
                    key={c.title}
                    className="flex flex-col gap-4 rounded-lg border border-background-200/80 bg-background-100/50 p-5 sm:flex-row sm:items-center sm:justify-between"
                  >
                    <div className="flex items-center gap-4">
                      <span
                        className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ${c.tone}`}
                      >
                        <i className={`${c.icon} text-xl`}></i>
                      </span>
                      <div>
                        <div className="flex items-center gap-2">
                          <p className="font-semibold text-foreground-950">{c.title}</p>
                          <span className="rounded bg-background-200/80 px-1.5 py-px text-[10px] text-foreground-600">
                            {c.badge}
                          </span>
                        </div>
                        <p className="mt-0.5 text-sm text-foreground-500">{c.channel}</p>
                        <p className="mt-1 text-xs text-foreground-400">{c.note}</p>
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        if (c.channel.includes("@")) copyMail(c.channel);
                      }}
                      className="whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                    >
                      {c.cta}
                      <i className="ri-arrow-right-line ml-1.5 align-middle"></i>
                    </button>
                  </div>
                ))}
              </div>

              {/* service hotline strip */}
              <div className="mt-5 flex flex-col gap-3 rounded-lg bg-foreground-950 p-5 sm:flex-row sm:items-center sm:justify-between">
                <div className="flex items-center gap-4">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500 text-accent-950">
                    <i className="ri-phone-line text-lg"></i>
                  </span>
                  <div>
                    <p className="font-semibold text-background-50">官方服务热线</p>
                    <p className="mt-0.5 text-sm tracking-wide text-foreground-300">
                      400-000-0888（工作日 09:00–18:00）
                    </p>
                  </div>
                </div>
                <div className="flex flex-wrap gap-2">
                  <span className="inline-flex items-center rounded-md bg-foreground-900 px-3 py-1.5 text-xs text-foreground-300">
                    <i className="ri-time-line mr-1"></i>7×12 客服在线
                  </span>
                  <span className="inline-flex items-center rounded-md bg-foreground-900 px-3 py-1.5 text-xs text-foreground-300">
                    <i className="ri-shield-check-line mr-1"></i>信息加密
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}